import React from 'react';
import styled from 'styled-components';

export const QuoteMarks = props => (
  <svg viewBox="50 390.191 400 220.617" {...props}>
    <description>Quotation Marks</description>
    <path
      d="M390.955,610.491c4.919,0,7.946-1.709,11.828-4.87c3.663-2.979,15.797-20.288,25.367-37.329
	c14.306-25.501,21.655-46.753,21.813-63.184L450,408.904c0-10.314-8.386-18.713-18.701-18.713H292.236
	c-10.304,0-18.702,8.398-18.702,18.713l0.024,116.248c0,10.327,8.386,18.726,18.701,18.726h81.983l0.659,3.663
	c1.257,6.909,1.904,13.965,1.904,20.972c0,7.495-0.707,14.722-2.124,22.095c-0.243,1.525-0.317,2.404-0.317,3.271
	C374.365,603.045,381.812,610.491,390.955,610.491L390.955,610.491z"
    />
    <path
      d="M167.407,610.809c4.931,0,7.959-1.709,11.816-4.858c3.662-2.967,15.796-20.276,25.378-37.342
	c14.319-25.513,21.655-46.765,21.814-63.171l0.048-96.229c0-10.303-8.398-18.688-18.701-18.688H68.7
	c-10.314,0.001-18.7,8.387-18.7,18.688l0.013,116.272c0,10.303,8.386,18.713,18.701,18.713h81.983l0.671,3.675
	c1.245,6.896,1.879,13.952,1.879,20.959c0,7.507-0.684,14.733-2.1,22.095c-0.256,1.525-0.33,2.417-0.33,3.271
	C150.818,603.35,158.264,610.809,167.407,610.809L167.407,610.809z"
    />
  </svg>
);

QuoteMarks.displayName = 'QuoteMarks';

export default styled(QuoteMarks)``;



// WEBPACK FOOTER //
// ./src/components/QuoteMarksIcon.js